import React from "react";
import { MessageCircle } from "lucide-react";
import { useSiteContent } from "@/contexts/SiteContentContext";
import { HOME } from "@/lib/homeContent";
import { useAssistant } from "@/components/SpainMoveAssistant";
import { GuideCta } from "@/components/GuideCta";
import { ScheduleCallButton } from "@/components/ScheduleCallButton";

const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

// Compact end-of-article layer: Ask (assistant) → Explore (guide) → Talk (call).
export function ArticleCta({ slug }) {
  const { section } = useSiteContent();
  const c = section("conversion_ctas", HOME.conversion_ctas);
  const assistant = useAssistant();
  return (
    <aside data-testid="article-cta" aria-label={c.article_cta_heading} className="mt-16 pt-10 border-t border-[#451C25]/15">
      <p className="text-2xl md:text-3xl leading-tight text-[#451C25]" style={{ ...K, fontWeight: 500 }}>{c.article_cta_heading}</p>
      <ol className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        <li>
          <p className="text-[#897756] text-[10px] tracking-[0.26em] uppercase font-semibold" style={K}>Ask</p>
          <button type="button" data-testid="article-ask-assistant" onClick={() => assistant?.open(`article_${slug}`)} className="group mt-2 inline-flex items-center gap-2 text-left text-[#451C25] text-lg leading-snug underline underline-offset-4 decoration-[#B3A17D] hover:decoration-[#451C25] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B3A17D]" style={S}>
            <MessageCircle size={16} className="shrink-0 text-[#897756]" aria-hidden="true" />
            {c.article_ask_label}
          </button>
        </li>
        <li>
          <p className="text-[#897756] text-[10px] tracking-[0.26em] uppercase font-semibold" style={K}>Explore</p>
          <GuideCta placement={`article_${slug}`} variant="compact" className="mt-2 !text-lg" prompt="" testId="article-guide-cta" />
        </li>
        <li>
          <p className="text-[#897756] text-[10px] tracking-[0.26em] uppercase font-semibold" style={K}>Talk</p>
          <div className="mt-2"><ScheduleCallButton size="sm" tone="burgundy" label="Schedule a Free Call" source={`article_${slug}`} testId="article-call-cta" /></div>
          <p className="mt-2 text-[#6B4954] text-[11px] tracking-[0.12em] uppercase" style={K}>{c.call_meta}</p>
        </li>
      </ol>
    </aside>
  );
}

export default ArticleCta;
